import { toast } from "react-toastify";

export const baseURL = process.env.REACT_APP_API_BASE_URL;

export const imageURL = baseURL + "uploads/";
export const apiUrl = baseURL + "api";

export const api = apiUrl;

export const saveRecords = async (payload, endpoint) => {
  try {
    // Fetch token from localStorage
    const response = await fetch(apiUrl + endpoint, {
      method: "POST", // Use POST method
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload), // Stringify the payload
    });
    return response.json();
  } catch (error) {
    console.error("fetahcData Error fetching data:", error);
    throw error; // Re-throw the error for further handling if needed
  }
};

export const getRecords = async (payload, endpoint) => {
  try {
    // Fetch token from localStorage
    const response = await fetch(apiUrl + endpoint, {
      method: "POST", // Use POST method
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload), // Stringify the payload
    });
    return response.json();
  } catch (error) {
    console.error("fetahcData Error fetching data:", error);
    throw error; // Re-throw the error for further handling if needed
  }
};

export const dropdownData = async (
  responseData,
  fieldName,
  selectedFieldName,
  isOtherDependentOnThis
) => {
  try {
    if (!responseData && responseData.length == 0) {
      return []; // Return empty array if no data is available
    }
    var options = [];
    responseData.forEach((element) => {
      options.push({
        label: element[fieldName],
        value: element.id,
        fieldName: selectedFieldName,
        isOtherDependentOnThis,
        data: responseData,
      });
    });
    const dropdownResponseData = [{ options: options }];
    return dropdownResponseData;
  } catch (error) {
    console.error("Error fetching data:", error);
    // Handle errors appropriately (throw error, display error message, etc.)
    throw error; // Re-throw the error for further handling if needed
  }
};

export const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
};

export const formatNumber = (value) => {
  if (value === null || value === undefined || value === "") return "0";
  const num = Number(value);
  if (isNaN(num)) return "0";
  const formatted = num.toFixed(2).toString();
  return formatted.replace(/\.00$/, "");
};
